// Lightweight helper to request a Cloudflare Turnstile token (invisible)
// Usage: const token = await requestTurnstileToken('quote');

const SITE_KEY = '0x4AAAAAAB8y_PBF1_Cm6URM';

function waitForTurnstile(maxWaitMs = 8000) {
  const start = Date.now();
  return new Promise((resolve, reject) => {
    function check() {
      if (window && window.turnstile && typeof window.turnstile.render === 'function') {
        resolve(window.turnstile);
        return;
      }
      if (Date.now() - start > maxWaitMs) {
        reject(new Error('Turnstile script not available'));
        return;
      }
      setTimeout(check, 100);
    }
    check();
  });
}

export async function requestTurnstileToken(action = undefined) {
  const turnstile = await waitForTurnstile();
  return new Promise((resolve, reject) => {
    const container = document.createElement('div');
    // Keep it out of layout flow
    container.style.position = 'fixed';
    container.style.left = '-9999px';
    container.style.width = '0';
    container.style.height = '0';
    document.body.appendChild(container);

    const cleanup = (widgetId) => {
      try { turnstile.remove(widgetId); } catch {}
      try { container.remove(); } catch {}
    };

    const widgetId = turnstile.render(container, {
      sitekey: SITE_KEY,
      size: 'invisible',
      retry: 'auto',
      action,
      callback: (token) => {
        cleanup(widgetId);
        resolve(token);
      },
      'error-callback': () => {
        cleanup(widgetId);
        reject(new Error('Turnstile error'));
      },
      'expired-callback': () => {
        cleanup(widgetId);
        reject(new Error('Turnstile token expired'));
      }
    });

    try {
      turnstile.execute(widgetId);
    } catch (e) {
      cleanup(widgetId);
      reject(e);
    }
  });
}

